import type { ParentPageInfos } from '@backmarket/http-api/src/api-specs-content/models/base-page-content'
import type { CMSPageType } from '@backmarket/http-api/src/api-specs-content/models/cms-page-type'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import type { Maybe } from '@backmarket/utils/types/Maybe'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CMS } from '~/scopes/cms/routes-names'
import { CMS_PAGE_TYPE_BY_ROUTE_NAME } from '~/scopes/cms/service/content-service.config'

import type { Crumb } from '../crumb'

type IntermediaryPathParams = {
  pageType: CMSPageType
  parentPageInfos?: Maybe<ParentPageInfos>
}

/* The current page and the parent page always have the same pageType */
export const getIntermediaryPath = ({
  pageType,
  parentPageInfos,
}: IntermediaryPathParams) => {
  if (isEmpty(parentPageInfos)) return []

  const { titleBreadcrumb: title, pageName } = parentPageInfos

  const resolveLocalizedRoute = useRouteLocationWithLocale()

  if (
    pageType === CMS_PAGE_TYPE_BY_ROUTE_NAME[CMS.GIFT_FINDER_MAIN] &&
    pageName === 'home'
  ) {
    return [
      {
        title,
        link: resolveLocalizedRoute({
          name: CMS.GIFT_FINDER_HOME,
        }),
      },
    ]
  }

  const crumbs: Crumb[] = [
    {
      title,
      link: resolveLocalizedRoute({
        name: pageType,
        params: {
          pageName,
        },
      }),
    },
  ]

  return crumbs
}
